import { render, staticRenderFns } from "./ProfileItems.vue?vue&type=template&id=c94ff24e&"
import script from "./ProfileItems.vue?vue&type=script&lang=ts&"
export * from "./ProfileItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports